import Vue from "vue"
import VueRouter from "vue-router"
import App from "./App.vue"
import routerConfig from "./router"
import store from "./store/index"
import Promise from "promise"
import VueCompositionApi from "@vue/composition-api"
import aegis from "../../installs/aegis"
import * as Sentry from "@sentry/browser"
import { Vue as VueIntegration } from "@sentry/integrations"

if (process.env.NODE_ENV === "debug") {
  Vue.config.devtools = true
} else if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://0362eb185be64f80a8768acc04b7de2c@report.url.cn/sentry/156",
    environment: process.env.NODE_ENV,
    release: "1.0.0",
    // tags: { page: "apple-gift-card" },
    sampleRate: process.env.NODE_ENV !== "production" ? 1 : 0.2,
    beforeSend: event => {
      if (process.env.NODE_ENV !== "production") {
        console.log(event)
        return null
      }
      return event
    },

    integrations: [new VueIntegration({ Vue, attachProps: true })]
  })
}

window.Promise = Promise

Vue.use(aegis)
Vue.use(VueRouter)
Vue.use(VueCompositionApi)

const router = new VueRouter(routerConfig)

export default new Vue({
  el: "#app",
  router,
  render: h => h(App),
  store
})
